import PercentField from "@legacy/core/fields/PercentField"
import { Component, Fragment } from "react"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { AccessCheck } from "@particles/index"
import ButtonGroup from "../../core/buttons/ButtonGroup"
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow"
import UniversalButton from "../../core/buttons/UniversalButton"

class InlineGeneralOverrideForm extends Component {
    renderButtons = () => {
        const { isNewAddition, requestAction } = this.props

        return (
            <ButtonGroup>
                <AccessCheck permissions={{
                    pricebook_edit_permission: PERMISSION_LEVEL.FULL
                }}>
                    <ButtonGroupRow>
                        <UniversalButton type="primary" text="Save" handler={(event) => requestAction(isNewAddition ? "ITEM_ADD" : "ITEM_SAVE")} />
                    </ButtonGroupRow>
                </AccessCheck>
                {isNewAddition ? (
                    <ButtonGroupRow>
                        <UniversalButton
                            type="secondary"
                            text="Cancel"
                            handler={(event) => requestAction("ITEM_CANCEL_ADD")}
                        />
                    </ButtonGroupRow>
                ) : (
                    <Fragment>
                        <ButtonGroupRow>
                            <UniversalButton
                                type="secondary"
                                text="Cancel Edits"
                                handler={(event) => requestAction("ITEM_CANCEL_EDITS")}
                            />
                        </ButtonGroupRow>
                        <AccessCheck permissions={{
                            pricebook_delete_permission: PERMISSION_LEVEL.FULL
                        }}>
                            <ButtonGroupRow>
                                <UniversalButton
                                    type="danger"
                                    text="Delete General Override"
                                    handler={(event) => requestAction("ITEM_DELETE")}
                                />
                            </ButtonGroupRow>
                        </AccessCheck>
                    </Fragment>
                )}
            </ButtonGroup>
        )
    }

    render() {
        const { item, onFormDataChange, errors } = this.props

        const itemErrors = item.errors || {}
        const cannotEditPricebook = window.CURRENT_USER?.permissions.pricebook_edit_permission < PERMISSION_LEVEL.FULL

        return (
            <div className="data-panel__list-select__form">
                <div className="data-panel__list-select" aria-label="Item Edit Form">
                    {itemErrors.non_field_error && (
                        <div className="data-panel__form__field__errors" aria-label="Non Field Error">
                            {itemErrors.non_field_error}
                        </div>
                    )}
                    <PercentField
                        fieldName="discount_percent"
                        fieldLabel="Discount"
                        fieldValue={item.discount_percent}
                        fieldOnChange={(discount_percent) => onFormDataChange("discount_percent", discount_percent)}
                        disabled={cannotEditPricebook}
                        min={null}
                        max="100"
                        errors={{...errors, ...itemErrors}}
                    ></PercentField>
                    {this.renderButtons()}
                </div>
            </div>
        )
    }
}

export default InlineGeneralOverrideForm
